const stateRoomLabels = {
  Interior: 'Interior',
  Outside: 'Ocean-View',
  Balcony: 'Balcony',
  Deluxe: 'Suite/Deluxe',
}

export default stateRoomLabels
